import { useEffect } from 'react';

function LifeBeyondWork() {
    useEffect(() => {
        document.title = "Life Beyond Work — Deepali Agrawal";
    }, []);

    return (
        <div className="section-padding">
            <div className="max-w-3xl">
                {/* Page Title */}
                <h1 className="text-3xl md:text-headline font-fraunces mb-12">
                    Life Beyond Work
                </h1>

                {/* Intro */}
                <div className="space-y-8 text-body-lg text-warm-gray-600 mb-16">
                    <p>
                        This space is for the parts of my practice that don't always fit into a brief.
                    </p>

                    <p>
                        Personal illustrations, experiments, unfinished ideas, and things that quietly influence how I see and design.
                    </p>
                </div>

                {/* Inspirations */}
                <section className="py-12 border-t border-warm-gray-200 mb-16">
                    <h2 className="text-lg font-medium text-warm-gray-500 mb-6 tracking-wide">
                        What Inspires Me
                    </h2>

                    <div className="space-y-4 text-body-lg text-warm-gray-600">
                        <p>
                            I'm inspired by everyday visuals, printed matter, objects with history, and slow creative processes.
                        </p>
                        <p>
                            Often, these explorations feed back into my professional work — in subtle ways.
                        </p>
                    </div>
                </section>

                {/* Work in Progress Note */}
                <section className="py-12 bg-cream-dark -mx-6 px-6 md:-mx-8 md:px-8 rounded-lg">
                    <p className="text-xl font-fraunces text-warm-gray-700 italic text-center">
                        This page is a work in progress, much like my practice.
                    </p>
                </section>

                {/* Placeholder for Future Content */}
                <section className="py-16 text-center">
                    <p className="text-warm-gray-500 text-sm uppercase tracking-wide mb-4">
                        Coming Soon
                    </p>
                    <p className="text-warm-gray-600">
                        Personal projects, illustrations, and creative explorations will be shared here.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default LifeBeyondWork;
